import React from "react";

const BuildSummary = () => {

    return(<div>This is build summary page. UI has some clarifications.</div>)
}

export default BuildSummary;